module.exports = __webpack_public_path__ + "img/8.077a5c7d.png";